const USER_PROFILE_PAGE_CONTANTS = {
  DEFAULT: 'DEFAULT',
  SIGNIN: 'SIGNIN',
  SIGNINML: 'SIGNINML',
  SIGNUP_PAGE: 'SIGNIN',
  RESET_PAGE: 'RESET',
  RESET_CONFIRMATION_PAGE: 'RESET_CONFIRMATION',
  SIGNEDIN_USER_PAGE: 'SIGNEDIN_USER',
  SIGNUP_FORM_PAGE: 'SIGNUP_FORM',
  VERIFY_MOBILE_NUMBER: 'VERIFY_MOBILE_NUMBER',
  VERIFY_MOBILE_NUMBERML: 'VERIFY_MOBILE_NUMBERML',
  EMAIL_LINKED: 'EMAIL_LINKED',
  EMAIL_LINKEDML: 'EMAIL_LINKEDML',
  VERIFY_EMAILML: 'VERIFY_EMAILML',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  LINK_ACCOUNTS: 'LINK_ACCOUNTS',
  SIGNIN_EMAIL: 'SIGNIN_EMAIL',
  SIGNIN_EMAILML: 'SIGNIN_EMAILML',
  EMAIL_MOBILE_LINKED: 'EMAIL_MOBILE_LINKED',
  LINK_SUCCESS: 'LINK_SUCCESS',
  LOADER: 'LOADER',
  PERSONAL_DETAILS: 'PERSONAL_DETAILS',
  EMAIL_LINKED_PERSONAL_DETAILS: 'EMAIL_LINKED_PERSONAL_DETAILS'
}

export default USER_PROFILE_PAGE_CONTANTS
